module.exports = __webpack_public_path__ + "static/media/loadhub-laptop.fafad632.jpg";